import { EmployeeAccessRolePrivilege } from "../types";

export enum UserPrivileges {
    EMPLOYEE_PRIV_ADMIN = 800,
    EMPLOYEE_PRIV_UPDATE_TIMESHEET = 690,
    USER_PRIV_UPDATE_REPORTING_EMP_TIMESHEETS = 550,
    EMPLOYEE_PRIV_SCHEDULE_TOOL = 801,
    VIEW_TIMESHEET = 925,
}

const privilegeCodeByRule: Partial<Record<UserPrivileges, string>> = {
    [UserPrivileges.VIEW_TIMESHEET]: "view-timesheet",
};

export const isPrivilege = (params: { privileges?: EmployeeAccessRolePrivilege[]; rule: UserPrivileges }): boolean => {
    const { privileges, rule } = params;
    const arr: EmployeeAccessRolePrivilege[] = privileges || [];
    // if (!privileges || !rule || privileges.length === 0) {
    //     // return false;
    //     return false;
    // }

    // Check if any privilege matches the rule
    return arr.some((privilege) => {
        const idCheck = privilege.os_role_privileges_definition_id == rule;
        const codeCheck =
            privilege.os_role_privilege_code == privilegeCodeByRule[rule] ||
            privilege.os_role_privilege_code == UserPrivileges[rule];

        return idCheck || codeCheck;
    });
};
